<template>
  <div class="card-container" @click="handleClickScreen">
    <molecule-hidden-self-check-in-input
      v-model="visitorInfo"
      :redirect-time="redirectTime"
      :counter-clear-visitor-info="counterClearVisitorInfo"
      @onFinishReadingVisitorInfo="onFinishReadingVisitorInfo"
    ></molecule-hidden-self-check-in-input>

    <molecule-setup-local-storage-card
      v-if="displayMode === 'setup'"
      :is-valid-x-api-key="isValidXApiKey"
      :is-fetching-site-option="isFetchingSiteOption"
      :site-option="siteOption"
      @onSaveXApiKeyToLocalStorage="onSaveXApiKeyToLocalStorage"
      @onSaveSelectedSiteIdToLocalStorage="onSaveSelectedSiteIdToLocalStorage"
    ></molecule-setup-local-storage-card>

    <!-- <molecule-select-self-check-in-list-card
      v-else-if="displayMode === 'select-check-in'"
      :available-self-check-in-list="availableSelfCheckInList"
      @onConfirmSelectCheckIn="onConfirmSelectCheckIn"
    ></molecule-select-self-check-in-list-card> -->

    <molecule-landing-card
      v-else-if="displayMode === 'landing'"
    ></molecule-landing-card>

    <molecule-loading-card
      v-else-if="displayMode === 'processing'"
    ></molecule-loading-card>

    <molecule-not-found-card
      v-else-if="displayMode === 'not-found'"
      :redirect-time="redirectTime"
      @onClickClose="onClickRedirectToLandingPage"
    ></molecule-not-found-card>

    <molecule-check-in-info-card
      v-else-if="displayMode === 'check-in-info'"
      :check-in-info="checkInData"
      :redirect-time="redirectTime"
      @onClickClose="onClickRedirectToLandingPage"
    ></molecule-check-in-info-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue"
import MoleculeDisplayCurrentDate from "@/components/molecules/selfCheckIn/MoleculeDisplayCurrentDate.vue"
import MoleculeDisplayCurrentTime from "@/components/molecules/selfCheckIn/MoleculeDisplayCurrentTime.vue"
import MoleculeLandingCard from "@/components/molecules/selfCheckIn/MoleculeLandingCard.vue"
import MoleculeLoadingCard from "@/components/molecules/selfCheckIn/MoleculeLoadingCard.vue"
import MoleculeNotFoundCard from "@/components/molecules/selfCheckIn/MoleculeNotFoundCard.vue"
import MoleculeCheckInInfoCard from "@/components/molecules/selfCheckIn/MoleculeCheckInInfoCard.vue"
import MoleculeHiddenSelfCheckInInput from "@/components/molecules/selfCheckIn/MoleculeHiddenSelfCheckInInput.vue"
import MoleculeSetupLocalStorageCard from "@/components/molecules/selfCheckIn/MoleculeSetupLocalStorageCard.vue"
import MoleculeSelectSelfCheckInListCard from "@/components/molecules/selfCheckIn/MoleculeSelectSelfCheckInListCard.vue"
export default {
  name: "OrganismSelfCheckIn",
  components: {
    BCard,
    MoleculeDisplayCurrentDate,
    MoleculeDisplayCurrentTime,
    MoleculeLandingCard,
    MoleculeLoadingCard,
    MoleculeNotFoundCard,
    MoleculeCheckInInfoCard,
    MoleculeHiddenSelfCheckInInput,
    MoleculeSetupLocalStorageCard,
    MoleculeSelectSelfCheckInListCard,
  },
  props: {
    displayMode: {
      type: String,
      required: true,
    },
    isValidXApiKey: {
      type: Boolean,
      required: true,
    },
    isFetchingSiteOption: {
      type: Boolean,
      required: true,
    },
    redirectTime: {
      type: Number,
      required: true,
    },
    siteOption: {
      type: Array,
      required: true,
    },
    availableSelfCheckInList: {
      type: Array,
      required: true,
    },
    checkInData: {
      type: Object,
      required: true,
    },
    counterClearVisitorInfo: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  emits: [
    "onUploadVisitorImage",
    "onSaveXApiKeyToLocalStorage",
    "onSaveSelectedSiteIdToLocalStorage",
    "onClickRedirectToLandingPage",
  ],
  computed: {
    visitorInfo: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },

  methods: {
    onSaveXApiKeyToLocalStorage() {
      this.$emit("onSaveXApiKeyToLocalStorage")
    },

    onSaveSelectedSiteIdToLocalStorage() {
      this.$emit("onSaveSelectedSiteIdToLocalStorage")
    },

    onFinishReadingVisitorInfo() {
      this.$emit("onFinishReadingVisitorInfo")
    },

    onClickRedirectToLandingPage() {
      this.$emit("onClickRedirectToLandingPage")
    },

    // onConfirmSelectCheckIn(updatedSelectedCheckIn) {
    //   this.$emit("onConfirmSelectCheckIn", updatedSelectedCheckIn)
    // },

    handleClickScreen() {
      if (this.displayMode === "landing") {
        this.$emit("onClearVisitorInfo")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  display: flex;
  position: relative;
  height: calc(100vh - 28px); // 28px is app layout padding
  justify-content: center;
  align-items: center;
}
</style>
